module.exports = __webpack_public_path__ + "static/assets/d79bf4bbb8df5542ffef65d9e61b37ed.svg";